import React from "react";
import { Warning, TrendDown, Coins } from "@phosphor-icons/react";
import { useLandingT } from "@/lib/landingI18n";

export const ProblemSection = ({ lang }) => {
  const t = useLandingT(lang);
  return (
    <section className="relative py-20 md:py-28">
      <div className="max-w-[1240px] mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-6">
            <div className="kicker">
              <span className="dot" />
              {t("problemKicker")}
            </div>
            <h2 className="h-section mt-5 text-white">{t("problemTitle")}</h2>
            <p className="mt-5 text-slate-300 text-base md:text-lg leading-relaxed max-w-xl">
              {t("problemBody")}
            </p>
          </div>

          <div className="lg:col-span-6">
            <div className="glass rounded-3xl p-6 md:p-8 relative overflow-hidden">
              {/* Crimson corner glow */}
              <div
                aria-hidden
                className="absolute -top-24 -end-24 w-64 h-64 rounded-full blur-3xl opacity-30"
                style={{
                  background:
                    "radial-gradient(closest-side, rgba(239,68,68,0.6), transparent 70%)",
                }}
              />
              <div className="grid grid-cols-3 gap-3">
                <div className="rounded-2xl p-4 border border-red-500/25 bg-red-500/5">
                  <TrendDown
                    size={22}
                    weight="duotone"
                    className="text-red-400"
                  />
                  <p className="mt-3 tabular text-3xl font-semibold crimson-text">
                    {t("problemStat1")}
                  </p>
                  <p className="mt-2 text-[10px] uppercase tracking-[0.14em] text-slate-400 leading-snug">
                    {t("problemStat1Label")}
                  </p>
                </div>
                <div className="rounded-2xl p-4 border border-emerald-500/30 bg-emerald-500/5">
                  <Coins size={22} weight="duotone" className="text-emerald-400" />
                  <p className="mt-3 tabular text-3xl font-semibold neon-text">
                    {t("problemStat2")}
                  </p>
                  <p className="mt-2 text-[10px] uppercase tracking-[0.14em] text-slate-400 leading-snug">
                    {t("problemStat2Label")}
                  </p>
                </div>
                <div className="rounded-2xl p-4 border border-white/10 bg-white/[0.02]">
                  <Warning size={22} weight="duotone" className="text-amber-300" />
                  <p className="mt-3 tabular text-3xl font-semibold text-white">
                    {t("problemStat3")}
                  </p>
                  <p className="mt-2 text-[10px] uppercase tracking-[0.14em] text-slate-400 leading-snug">
                    {t("problemStat3Label")}
                  </p>
                </div>
              </div>

              <div className="mt-6 rounded-2xl border border-emerald-500/25 bg-emerald-500/5 p-4">
                <p className="text-sm md:text-base text-slate-200">
                  <span className="crimson-text font-semibold">$500</span>{" "}
                  loss on a single mispriced load ={" "}
                  <span className="neon-text font-semibold">2+ years</span> of this
                  subscription.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
